export default __webpack_public_path__ + "static/media/2020 (1).4d0e3ad0.jpg";